import { render, staticRenderFns } from "./UploadAlert.vue?vue&type=template&id=5362d0a2&scoped=true"
import script from "./UploadAlert.vue?vue&type=script&lang=js"
export * from "./UploadAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5362d0a2",
  null
  
)

export default component.exports